var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInstitutionFillIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#0D968F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.4583 18.4583H13.4583C12.2915 18.4583 11.7081 18.4583 11.2624 18.6854C10.8704 18.8851 10.5517 19.2038 10.352 19.5959C10.1249 20.0415 10.1249 20.6249 10.1249 21.7917V28.875M28.8749 28.875V13.4583C28.8749 12.2916 28.8749 11.7082 28.6478 11.2625C28.4481 10.8705 28.1294 10.5518 27.7374 10.3521C27.2918 10.125 26.7084 10.125 25.5416 10.125H21.7916C20.6248 10.125 20.0414 10.125 19.5958 10.3521C19.2038 10.5518 18.8851 10.8705 18.6853 11.2625C18.4583 11.7082 18.4583 12.2916 18.4583 13.4583V28.875M29.9166 28.875H9.08325M22.1041 14.2917H25.2291M22.1041 18.4583H25.2291M22.1041 22.625H25.2291",
    stroke: "#F7F8F9",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstitutionFillIcon);
export default __webpack_public_path__ + "static/media/institution-fill-icon.b0ff34db9e54ad8dbb6512f3d984d8d3.svg";
export { ForwardRef as ReactComponent };